import React from "react"

export default () => (
  <div>
    <h1>Thank you!</h1>
    <p>This is a custom thank you page for form submissions</p>
  </div>
)
